module.exports = __webpack_public_path__ + "img/52a4e89.jpg";